import { useState } from "react";
import { useTranslation } from "react-i18next";

interface HelpTextProps {
  text?: string;
}

export const HelpText = ({ text }: HelpTextProps) => {
  const [htmlPreview, setHtmlPreview] = useState(true);
  const { t } = useTranslation();

  return (
    <>
      {`Help Text ${htmlPreview ? "(preview)" : "(raw)"}`}
      <label>
        <input
          type="checkbox"
          checked={htmlPreview}
          onChange={() => setHtmlPreview(!htmlPreview)}
        />
        {t(`HTML Preview`)}
      </label>
      <div>
        {text ? (
          htmlPreview ? (
            <div dangerouslySetInnerHTML={{ __html: `${text}` }} />
          ) : (
            `${text}`
          )
        ) : (
          `(no help text)`
        )}
      </div>
    </>
  );
};
